import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import Button from 'components/DesignSystem/Button';
import useDatedImageDownload from 'hooks/useDatedImageDownload';
import useMJOPrediction from 'hooks/Meteorology/Weather/Area/Status/MJO/useMJOPrediction';
import CentralizedSpinner from 'components/CentralizedSpinner';
import EnlargeableImage from 'components/Meteorology/Fields/SynopticCharts/SynopticChart/Map/EnlargeableImage';
import Selector from 'components/DesignSystem/Selector';
import useIsMobile from 'utils/hooks/useIsMobile';
import StatusCard from 'components/Meteorology/Weather/Area/Status/Mobile/StatusCard';

export default function PredictionPanel({
  models, variables,
}: {
  models: string[], variables: string[],
}) {
  const isMobile = useIsMobile();
  const [model, setModel] = useState('');
  const [variable, setVariable] = useState('');
  const { predictionImageBase64, predictionImageLoading } = useMJOPrediction({ model, variable });
  const filename = `mjo_prediction_${model}_${variable}`;
  const {
    onDownloadClick,
    downloadDisabled,
  } = useDatedImageDownload(predictionImageBase64, predictionImageLoading, filename);

  const modelSelector = (
    <Selector
      id="predictionModelSelect"
      placeholder="Modelo"
      value={model}
      setValue={setModel}
      containerClassName="flex-grow-1 me-2"
    >
      {models.map((option) => (
        <option key={option} value={option}>{option}</option>
      ))}
    </Selector>
  );

  const variableSelector = (
    <Selector
      id="variableSelect"
      placeholder="Variável"
      value={variable}
      setValue={setVariable}
      containerClassName="flex-grow-1 me-2"
    >
      {variables.map((option) => (
        <option key={option} value={option} label={option}>{option}</option>
      ))}
    </Selector>
  );

  const downloadButton = (
    <Button
      id="predictionImageDownloadButton"
      small
      className="icon-button weather-download-button"
      onClick={onDownloadClick}
      disabled={downloadDisabled}
      icon="download"
    />
  );

  if (isMobile) {
    return (
      <StatusCard title="PREVISÃO ESPACIAL">
        <div className="status-controls-mobile">
          {modelSelector}
          {variableSelector}
          {downloadButton}
        </div>
        {predictionImageLoading && <CentralizedSpinner />}
        {predictionImageBase64 && (
          <EnlargeableImage src={`data:image/png;base64,${predictionImageBase64}`} className="mt-3" />
        )}
      </StatusCard>
    );
  }

  return (
    <Card className="shadow-sm forecast-instruction-card h-100">
      <Card.Header>
        PREVISÃO ESPACIAL
      </Card.Header>
      <Card.Body>
        <div className="d-flex justify-content-between mt-3 me-3 align-items-center">
          {modelSelector}
          {variableSelector}
          {downloadButton}
        </div>
        {predictionImageLoading && <CentralizedSpinner />}
        <EnlargeableImage src={`data:image/png;base64,${predictionImageBase64}`} className="mt-3" />
      </Card.Body>
    </Card>
  );
}
